import { call, take, put, fork, all, select } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { fetchJson } from 'src/utils/fetch';
import format from 'src/utils/format';
import { inquiryAndMentalConsultStatic } from 'src/utils/tool';
import { InquiryActionTypes } from './type';
// import * as Sentry from "@sentry/browser";

function* fetch_inquiry_no() {
  while (true) {
    const action = yield take(InquiryActionTypes.FETCH_INQUIRY_NO);
    console.log(action);
    // let { payload: { isCompel = false } = {} } = action;
    try {
      // const {
      //   inquiry: { create },
      // } = yield select();
      // if (!isCompel && create.inquiryNo && create.inquiryNo !== '') {
      //   return;
      // }

      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/bizno/getByType',
        type: 'POST',
        isloading: false,
        action,
        data: { bizNoType: 'INQUIRY_NO' },
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        const { onSuccess } = action.payload || {};
        yield put({ type: InquiryActionTypes.FETCH_INQUIRY_NO_SUCCESS, data: result });
        onSuccess && onSuccess();
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_inquiry_no--------' + error.message);
    }
  }
}

function* cancel_inquiry() {
  while (true) {
    const action = yield take(InquiryActionTypes.CANCEL_INQUIRY);
    try {
      const { inquiryId } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/inquiry/cancel',
        type: 'GET',
        action,
        data: { inquiryId },
      });
      if (res && res.code === '0') {
        // StaticToast.success('问诊单取消成功');
        yield put({
          type: InquiryActionTypes.FETCH_INQUIRY_LIST,
          options: {
            currentPage: 1,
            pageSize: 10,
          },
        });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('cancel_inquiry--------' + error.message);
    }
  }
}

function* fetch_inquiry_detail() {
  while (true) {
    const action = yield take(InquiryActionTypes.FETCH_INQUIRY_DETAIL);
    try {
      const { options, onSuccess } = action;
      const { option = {} } = options || {};
      const res = yield call(fetchJson, {
        url: option.isCheck ? '/api/api/v1/rj/change/inquiry/detail' : '/api/api/v1/patient/inquiry/detail',
        type: 'POST',
        isloading: false,
        action,
        data: { ...options, option: { ...option, needPatient: true } },
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        // inquiryMentalConsultMap 为 心理咨询 or 问诊单 ，部分共用页面表态映射字段
        const nextResult = { ...result, inquiryMentalConsultMap: inquiryAndMentalConsultStatic(result.inquiryTimingType) };
        typeof onSuccess === 'function' && onSuccess(nextResult);
        yield put({ type: InquiryActionTypes.FETCH_INQUIRY_DETAIL_SUCCESS, data: nextResult });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_inquiry_detail--------' + error.message);
    }
  }
}

function* fetch_inquiry_list() {
  while (true) {
    const action = yield take(InquiryActionTypes.FETCH_INQUIRY_LIST);
    try {
      const { options, onSuccess } = action;
      const {
        inquiry: { list },
      } = yield select();
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/inquiry/list/page',
        type: 'POST',
        data: {
          option: {
            needStaff: true,
            needPatient: true,
            needDoctorsEvaluate: true,
            needDiagnosis: true,
            // needs
          },
          ...options,
        },
        isloading: true,
        action,
      });
      if (res && res.code === '0') {
        const data: any[] = [];
        const { result: { totalPage = 1, resultList = [], totalItem = 0 } = {} } = res;
        if (totalItem === list.length) {
          return;
        }
        resultList.length &&
          resultList.forEach((element) => {
            const obj = {
              avatar: element.medicalStaff.headPortrait || '',
              inquiryId: element.id || '',
              inquiryNo: element.inquiryNo || '',
              illnessDescription: element.illnessDescription || '',
              inquiryTime: element.inquiryTime || '',
              inquiryStatus: element.inquiryStatus || '',
              staffName: element.medicalStaff.staffName || '',
              staffId: element.medicalStaff.id || '',
              staffProfessionalTitle: element.medicalStaff.staffProfessionalTitle || '',
              receptionDepartmentCode: element.medicalStaff.workDepartment || '',
              firstWorkOrgName: element.medicalStaff.firstWorkOrgName || '',
              productId: element.productId || '',
              price: element.medicalStaff.medicalStaffServiceList[0].specialPrice || '',
              patientName: element.patient.patientName || '',
              patientId: element.patient.id || '',
              patientAge:
                format.GetAgeByBirthday(
                  format.date(element.patient.patientBirthday, 'yyyy-MM-dd')
                ) || '',
              patientGender: element.patient.patientGender || '',
              evaluateType: (element.doctorsEvaluate && element.doctorsEvaluate.evaluateType) || '',
              existEMR: element.existEMR || false,
            };
            data.push(obj);
          });
        typeof onSuccess === 'function' && onSuccess();
        yield put({
          type: InquiryActionTypes.FETCH_INQUIRY_LIST_SUCCESS,
          data,
          totalPage,
          currentPage: options.currentPage,
        });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

function* upload_file() {
  while (true) {
    const action = yield take(InquiryActionTypes.UPLOAD_FILE);
    try {
      const { formData } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/attchment/upload',
        type: 'UPLOAD',
        isloading: true,
        action,
        data: formData,
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        yield put({
          type: InquiryActionTypes.UPLOAD_FILE_SUCCESS,
          data: {
            ...result[0],
            attachmentDownloadUrl: `${result[0].attachmentDownloadUrl}`,
          },
        });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('upload_file--------' + error.message);
    }
  }
}

function* submit_inquiry() {
  while (true) {
    const action = yield take(InquiryActionTypes.SUBMIT_INQUIRY);
    try {
      const { onSuccess, data: { isClear = false } = {} } = action;
      const { inquiry: { create } } = yield select();
      const { 
        policyNo = '', 
        orderPreferenceList = [], 
        inquiryNo = '', 
        cardNo = '', 
        orderAmount, 
        orderRealAmount, 
        deliveryAddressId, 
        illnessDescription, 
        platformCode = '', 
        orderType = '', 
        inquiryType = '', 
        deliveryWay = '', 
        orderGoods = [], 
        staffId, 
        workDepartment = '', 
        useRightsAndDiscount = {}, 
        departmentCode = '',
        professionalInfo = {}, // 三甲问诊-额外字段
      } = create || {};
      const data: any = {
        businessEntry: {
          ...create,
          workDepartment: workDepartment || departmentCode === '-1' ? '' : departmentCode,
          illnessDescription: !illnessDescription ? '其他' : illnessDescription,
          // staffId: THIRD_PLATFORM_RESOURCECODE.ZAHY === platformCode ? goodsId : '',
          staffId,
          inquiryThirdRelationList: [{ thirdPlatformCode: platformCode }],
          ...professionalInfo,
        },
        // departmentCode 为选择科室的 workDepartment 为监管模式选择的
        workDepartment: workDepartment || departmentCode === '-1' ? '' : departmentCode,
        orderPreferenceList,
        orderGoods,
        orderType: orderType || 'inquiry',
        relatedBizNo: inquiryNo,
        orderAmount,
        orderRealAmount,
        deliveryAddressId,
        deliveryWay,
        bizType: inquiryType || 'I',
        cardNo: cardNo || '',
        platformCode,
        policyNo,
        valueAddedService: useRightsAndDiscount.drawVasCode, // 由于新业务保单下可能有多个权益，所以放开，并把选择的权益带给后端
      };

      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/order/unifiedOrder',
        type: 'POST',
        data,
        isloading: true,
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        typeof onSuccess === 'function' && onSuccess(result);
        isClear &&
          (yield put({
            type: InquiryActionTypes.SUBMIT_INQUIRY_SUCCESS,
            data: { uid: format.guid() },
          }));
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

function* fetch_inquiry_price() {
  while (true) {
    const action = yield take(InquiryActionTypes.FETCH_INQUIRY_PRICE);
    try {
      const { onSuccess, data } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/preference/calculate',
        type: 'POST',
        data: {
          ...data,
        },
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        typeof onSuccess === 'function' && onSuccess(result);
        yield put({ type: InquiryActionTypes.FETCH_INQUIRY_PRICE_SUCCESS, data: result });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('submit_inquiry--------' + error.message);
    }
  }
}

function* fetch_evaluate_by_inquiry() {
  while (true) {
    const action = yield take(InquiryActionTypes.FETCH_EVALUATE_BY_INQUIRY);
    try {
      const { inquiryId } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/docEvaluate/queryByInquiry',
        type: 'GET',
        data: {
          inquiryId,
        },
        action,
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        yield put({ type: InquiryActionTypes.FETCH_EVALUATE_BY_INQUIRY_SUCCESS, data: result });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_evaluate_by_inquiry--------' + error.message);
    }
  }
}

function* fetch_evaluate_tags() {
  while (true) {
    const action = yield take(InquiryActionTypes.FETCH_EVALUATE_TAGS);
    try {
      const { onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/tags/query',
        type: 'POST',
        data: {
          tagType: 1,
        },
        isloading: false,
        action,
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        typeof onSuccess === 'function' && onSuccess();
        yield put({ type: InquiryActionTypes.FETCH_EVALUATE_TAGS_SUCCESS, data: result });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_evaluate_tags' + error.message);
    }
  }
}

function* fetch_ump_evaluate_tags() {
  while (true) {
    const action = yield take(InquiryActionTypes.FETCH_UMP_EVALUATE_TAGS);
    try {
      const { onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/video/inquiry/tag/list',
        type: 'GET',
        isloading: false,
        action,
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        typeof onSuccess === 'function' && onSuccess();
        yield put({ type: InquiryActionTypes.FETCH_UMP_EVALUATE_TAGS_SUCCESS, data: result });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_evaluate_tags' + error.message);
    }
  }
}

function* submit_evaluate() {
  while (true) {
    const action = yield take(InquiryActionTypes.SUBMIT_EVALUATE);
    try {
      const { data, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/docEvaluate/submit',
        type: 'POST',
        data: {
          ...data,
          bizType: 1,
        },
        action,
      });
      if (res && res.code === '0') {
        StaticToast.success('提交成功 感谢您的评价');
        typeof onSuccess === 'function' && onSuccess();
        yield put({ type: InquiryActionTypes.SUBMIT_EVALUATE_SUCCESS });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('submit_evaluate--------' + error.message);
    }
  }
}


// 获取第三方医生详情
function* sagaThirdDoctorDetail() {
  while (true) {
    const { payload: { inquiryId = '', inquiryNo = '', thirdDoctorId = '' } = {} } = yield take(InquiryActionTypes.THIRD_DOCTOR_DETAIL);
    try {
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/third/doctor/detail',
        type: 'GET',
        data: {
          inquiryId,
          thirdDoctorId,
          inquiryNo,
        },
        isloading: true,
      });
      if (res && res.code === '0') {
        yield put({ type: InquiryActionTypes.THIRD_DOCTOR_DETAIL_REDUCER, data: res.result || {} });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

function* fetchProductList() {
  while (true) {
    const { payload = {}, onSuccess } = yield take(InquiryActionTypes.PRODUCT_LIST);
    try {
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/product/list',
        type: 'POST',
        data: payload,
        needLogin: false,
        isloading: true,
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        yield put({ type: InquiryActionTypes.PRODUCT_LIST_REDUCER, data: result });
        onSuccess && onSuccess(result);
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      onSuccess && onSuccess([]);
    }
  }
}

function* fetchThirdDoctorProfessionSymptoms() {
  while (true) {
    const { payload = {}, onSuccess } = yield take(InquiryActionTypes.FETCH_THIRD_DOCTOR_PROFESSION);
    try {
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/inquiryTertiary/queryList',
        type: 'POST',
        data: payload,
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        yield put({ type: InquiryActionTypes.FETCH_THIRD_DOCTOR_PROFESSION, data: result });
        onSuccess && onSuccess(result);
      } else {
        onSuccess && onSuccess([]);
        StaticToast.error('网络异常，请稍后重试');
        onSuccess && onSuccess([]);
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      onSuccess && onSuccess([]);
    }
  }
}

export default function* root() {
  yield all([
    fork(fetch_inquiry_detail),
    fork(fetch_inquiry_list),
    fork(fetch_inquiry_no),
    fork(cancel_inquiry),
    fork(fetch_evaluate_by_inquiry),
    fork(fetch_evaluate_tags),
    fork(fetch_ump_evaluate_tags),
    fork(upload_file),
    fork(submit_inquiry),
    fork(submit_evaluate),
    fork(fetch_inquiry_price),
    fork(sagaThirdDoctorDetail),
    fork(fetchProductList),
    fork(fetchThirdDoctorProfessionSymptoms),
  ]);
}
